import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import FetchSyarahv2 from "@/common/fetchSyarahv2";
import { ValidationException } from "@/common/exceptions/ValidationException";
export var api__updateCustomer = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().post("customer/update-profile", data);
        case 1:
          res = _context.v;
          console.log(res, 'update customer');
          return _context.a(2, (res === null || res === void 0 ? void 0 : res.data) || null);
      }
    }, _callee);
  }));
  return function api__updateCustomer(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__unsubscribeInterest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    var res;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetcher().post("customer/unsubscribe-interest", data);
        case 1:
          res = _context2.v;
          return _context2.a(2, res.data || null);
      }
    }, _callee2);
  }));
  return function api__unsubscribeInterest(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__loginOrSignup = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(phoneNumber) {
    var formData, res;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          formData = new FormData();
          formData.append("phone_number", phoneNumber);
          _context3.n = 1;
          return FetchSyarahv2({
            throwValidationException: true
          }).post("/auth/login-or-signup", formData);
        case 1:
          res = _context3.v;
          return _context3.a(2, res.data.data);
      }
    }, _callee3);
  }));
  return function api__loginOrSignup(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__logoutUser = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return fetcher().post("/customer/logout")["catch"](function (err) {
            console.log("/customer/logout err", err);
            return null;
          });
        case 1:
          return _context4.a(2, _context4.v);
      }
    }, _callee4);
  }));
  return function api__logoutUser() {
    return _ref4.apply(this, arguments);
  };
}();
export var api__updateUserCityProfile = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(city) {
    var formData, res;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          formData = new FormData();
          formData.append("city_id", city);
          _context5.n = 1;
          return fetcher().post("customer/update-profile", formData);
        case 1:
          res = _context5.v;
          return _context5.a(2, res.data.data);
      }
    }, _callee5);
  }));
  return function api__updateUserCityProfile(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
export var api__updateUserNameProfile = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(name) {
    var formData, res;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          formData = new FormData();
          formData.append("full_name", name);
          _context6.n = 1;
          return fetcher().post("customer/update-profile", formData);
        case 1:
          res = _context6.v;
          return _context6.a(2, res.data.data);
      }
    }, _callee6);
  }));
  return function api__updateUserNameProfile(_x5) {
    return _ref6.apply(this, arguments);
  };
}();
export var api__updateUserMobileProfile = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(mobile) {
    var formData, res;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          formData = new FormData();
          formData.append("phone_number", mobile);
          formData.append("is_phone_number", true);
          _context7.n = 1;
          return fetcher().post("customer/update-profile", formData);
        case 1:
          res = _context7.v;
          if (!res.data.errors) {
            _context7.n = 2;
            break;
          }
          throw ValidationException.factoryFromAxios(res);
        case 2:
          return _context7.a(2, res.data.data);
      }
    }, _callee7);
  }));
  return function api__updateUserMobileProfile(_x6) {
    return _ref7.apply(this, arguments);
  };
}();
export var api__togglePostToFavorite = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(postId) {
    var _res$data, _res$data$data;
    var data, res;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          data = new FormData();
          data.append("post_id", postId);
          data.append("is_online", "1");
          _context8.n = 1;
          return fetcher().post("/customer/add-delete-favourite", data);
        case 1:
          res = _context8.v;
          return _context8.a(2, !!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data.is_favorite));
      }
    }, _callee8);
  }));
  return function api__togglePostToFavorite(_x7) {
    return _ref8.apply(this, arguments);
  };
}();